import { render } from "./PublicationProfile.vue.js?vue&type=template&id=3f65dc89!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProfile.vue?vue&type=template&id=3f65dc89"
import script from "./PublicationProfile.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProfile.vue?vue&type=script&lang=js"
export * from "./PublicationProfile.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProfile.vue?vue&type=script&lang=js"

import "./PublicationProfile.vue.scss?vue&type=style&index=0&id=3f65dc89&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProfile.vue?vue&type=style&index=0&id=3f65dc89&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/PublicationProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f65dc89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f65dc89', __exports__)) {
    api.reload('3f65dc89', __exports__)
  }
  
  module.hot.accept("./PublicationProfile.vue.js?vue&type=template&id=3f65dc89!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProfile.vue?vue&type=template&id=3f65dc89", () => {
    api.rerender('3f65dc89', render)
  })

}


export default __exports__